import {
  MultiSelectWithTag,
  SearchableSelect,
} from "@risalabs_frontend_org/oasis-ui-kit";
import { Button } from "risa-oasis-ui_v2";
import { NarAgentGridInsuranceOption } from "../hooks/useNarAgentGridInsuranceOptions";
import {
  filterNarAgentGridJCodeOptions,
  NarAgentGridJCodeOption,
} from "../utils/narAgentGridJCodeOptions";

export interface NarAgentGridSearchFiltersProps {
  activeTab: string;
  insuranceOptions: NarAgentGridInsuranceOption[];
  selectedInsurance: string;
  onInsuranceChange: (value: string) => void;
  selectedJCodes: string[];
  onJCodesChange: (values: string[]) => void;
  jCodeOptions: NarAgentGridJCodeOption[];
  isLoadingJCodes: boolean;
  isSearchDisabled: boolean;
  onSearch: () => void;
}

/**
 * Insurance, J-code filters, and search button for the NAR Agent Grid page.
 */
const NarAgentGridSearchFilters = ({
  activeTab,
  insuranceOptions,
  selectedInsurance,
  onInsuranceChange,
  selectedJCodes,
  onJCodesChange,
  jCodeOptions,
  isLoadingJCodes,
  isSearchDisabled,
  onSearch,
}: NarAgentGridSearchFiltersProps) => (
  <div className="mb-4 flex w-full flex-row gap-4">
    <div className="w-1/4">
      <SearchableSelect
        key={`insurance-${activeTab}`}
        id="insurance"
        label="Insurance"
        options={insuranceOptions}
        value={selectedInsurance}
        onOptionChange={(option) => onInsuranceChange(option.value)}
        placeholder="Select Insurance"
        searchPlaceholder="Search insurance"
      />
    </div>
    <div className="min-w-0 flex-1">
      <div className="multi-select--label mb-1 text-tiny font-medium text-primaryGray-3">
        Drugs (J-Codes)
      </div>
      <MultiSelectWithTag
        key={`j-codes-${activeTab}-${selectedInsurance}`}
        options={jCodeOptions}
        value={selectedJCodes}
        onChange={onJCodesChange}
        onSearch={(query) =>
          filterNarAgentGridJCodeOptions(jCodeOptions, query)
        }
        placeholder={isLoadingJCodes ? "Loading J-codes..." : "Select J-codes"}
        searchPlaceholder="Search or type J-code"
        searchMinChars={1}
        allowCreateOnSearchEnter
        onCreateOptionFromSearch={(query) => {
          const trimmed = query.trim();
          return { id: trimmed, label: trimmed };
        }}
        disabled={!selectedInsurance || isLoadingJCodes}
        hideFooter
        dropdownWidth="100%"
        horizontalScrollTags
      />
    </div>
    <div className="mt-6 w-auto">
      <Button
        buttonType="secondary"
        size="medium"
        disabled={isSearchDisabled}
        onClick={onSearch}
      >
        Search
      </Button>
    </div>
  </div>
);

export default NarAgentGridSearchFilters;
